import React from "react";
import "./style.css";

export default function Spinner() {

  return (
    <div className="sk-chase">
      <div className="sk-chase-dot"/>
      <div className="sk-chase-dot"/>
      <div className="sk-chase-dot"/>
      <div className="sk-chase-dot"/>
      <div className="sk-chase-dot"/>
      <div className="sk-chase-dot"/>
    </div>
  )

}


// WEBPACK FOOTER //
// ./src/components/Spinner/index.js